<template>
	<div>
		<div>
			<div class="container">
				<h2>BOARD CONTROL</h2>
				<div class="wallet-address">
					{{ account }}
				</div>
				<div class="balance">
					<img
						:src="require('@/assets/images/board-control/k9_icon.png')"
						alt="">
					{{ totalPendingReward }}
				</div>
				<!-- <div class="pending-reward">
					({{ totalPendingReward }} PENDING)
				</div> -->
			</div>
			<div class="tabs-wrap">
				<div class="tab-nav container">
					<div
						class="link-tab"
						:class="{ active: activeTab === 'bulldroids' }"
						@click.prevent="activeTab = 'bulldroids'">
						my bulldroidS
					</div>
					<!-- <div
						class="link-tab"
						:class="{ active: activeTab === 'bulldro-sheds' }"
						@click.prevent="activeTab = 'bulldro-sheds'">
						my bulldro-sheds
					</div> -->
					<!-- <div
						class="link-tab"
						:class="{ active: activeTab === 'history' }"
						@click.prevent="activeTab = 'history'">
						history
					</div> -->
				</div>
				<div class="line-pink" />
				<div class="tab-content container">
					<BulldroidList :account="account" />
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue';

import { useWallet } from '@/composables/wallet';
import { totalPendingReward } from '@/composables/staking';

import BulldroidList from '@/components/BulldroidList.vue';

const {
	account,
} = useWallet();

const activeTab = ref('bulldroids');
</script>
